.container {
  display: flex;
  align-items: center;

  :global {
    button:disabled.ant-pagination-item-link:hover {
      --ant-color-bg-text-hover: transparent;
      --ant-color-bg-text-active: transparent;
    }

    .ant-pagination.ant-pagination-simple.ant-pagination-small
      .ant-pagination-simple-pager {
      --ant-pagination-item-spacing-actual: 8px;

      align-items: flex-end;

      > input {
        width: calc(var(--ant-control-height-lg) * 1);
      }
    }
  }
}
